import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import VueTheMask from 'vue-the-mask'
import store from './store/store.js'

import axios from 'axios'
import * as VueGoogleMaps from "vue2-google-maps";

Vue.config.productionTip = false;
Vue.use(VueTheMask);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDJuoIdZIPQGPN0nTwXfcWudnbkbh1iyDc"
  }
  
});
Vue.use(VueGoogleMaps.Marker);

axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
